import { Autocomplete, CircularProgress } from "@mui/material";
import React from "react";
import { CustomTextField } from "../formsComponents";
import { ISelectOption } from "../../constants/types";
import { debounce } from "lodash";
import { api } from "../../api/api";
import { IAutoCompleteSearchesProps } from "./AutoCompleteSearches.types";
import { IInsurerCode } from "../../redux/insurer/insurer.types";

export const BrokerCodeAutoSearch: React.FC<IAutoCompleteSearchesProps> = (
  props
) => {
  const { value, onSelect } = props;
  const [loading, setLoading] = React.useState(false);
  const [searchResults, setSearchResults] = React.useState<ISelectOption[]>([]);
  const [searchText, setSearchText] = React.useState("");

  const fetchInsurers = debounce(async (value) => {
    setLoading(true);
    try {
      const res = await api.get(`/insurance/get-insurer-code?status=ACTIVE&column=insurer_code&column=name&value=${value}`);
      const data: IInsurerCode[] = res.data.data;
      const finalData: ISelectOption[] = [];
      for (const insurer of data) {
        if (insurer.insurer_code) {
          finalData.push({
            label: `${insurer.insurer_code} (${insurer.name})`,
            value: insurer.insurer_code,
          });
        }
      }
      setSearchResults(finalData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }, 500);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;
    fetchInsurers(value);
    setSearchText(value);
  };
  const getOptionLabel = (option: string | ISelectOption) => {
    if (typeof option === "string") {
      return option;
    }
    return option.label;
  };

  React.useEffect(() => {
    if (value) {
      setSearchText(value);
      fetchInsurers(value);
    } else {
      setSearchText("");
    }
  }, [value]);

  return (
    <>
      <Autocomplete
        options={searchResults.map((result) => ({
          label: result.label,
          value: result.value,
        }))}
        sx={{
            ".MuiOutlinedInput-root": {
                paddingTop: '2px',
                paddingBottom: '2px',
                fontSize: "0.8rem",
                color: "rgb(38, 38, 38)",
              },
          }}
        value={searchResults.find((option) => option.value === value) || null}
        defaultValue={value}
        getOptionLabel={getOptionLabel}
        onChange={(e, newValue) => {
          if (newValue && typeof newValue !== "string") {
            onSelect(newValue);
          }
          else{
            onSelect({label: '', value: ''})
          }
        }}
        renderInput={(params) => (
          <CustomTextField
            {...params}
            fullWidth
            value={searchText}
            onChange={handleChange}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading && <CircularProgress color="inherit" size={20} />}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </>
  );
};
